export default __webpack_public_path__ + "6e437e920938e5381233795466640393.svg";